import { type FirebaseApp, initializeApp } from 'firebase/app'
import { type Auth, connectAuthEmulator, getAuth } from 'firebase/auth'
import { type Firestore, connectFirestoreEmulator, getFirestore } from 'firebase/firestore'
import { type Functions, connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { type FirebaseStorage, connectStorageEmulator, getStorage } from 'firebase/storage'

import { FUNCTIONS_REGION, getFirebaseConfig, useEmulators } from './config'

interface FirebaseServices {
  app: FirebaseApp
  auth: Auth
  firestore: Firestore
  functions: Functions
  storage: FirebaseStorage
}

let services: FirebaseServices | undefined

function getServices(): FirebaseServices {
  if (services) {
    return services
  }

  const app = initializeApp(getFirebaseConfig())
  const auth = getAuth(app)
  const firestore = getFirestore(app)
  const functions = getFunctions(app, FUNCTIONS_REGION)
  const storage = getStorage(app)

  if (useEmulators) {
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
    connectFirestoreEmulator(firestore, 'localhost', 8080)
    connectFunctionsEmulator(functions, 'localhost', 5001)
    connectStorageEmulator(storage, 'localhost', 9199)
  }

  services = { app, auth, firestore, functions, storage }
  return services
}

export function getFirebaseAuth(): Auth {
  return getServices().auth
}

export function getFirebaseFirestore(): Firestore {
  return getServices().firestore
}

export function getFirebaseFunctions(): Functions {
  return getServices().functions
}

export function getFirebaseStorage(): FirebaseStorage {
  return getServices().storage
}
